import Vue from 'vue'
import { fb, au } from '../plugins/firebase'
import { momento } from '../plugins/moment'
import { limpiar } from '../mixins/limpiar'

export default {
  namespaced: true,
  state: {
    clientes: [],
    cliente: {},
    cotizaciones: [],
    compras: [],
    comunas: []
  },
  mutations: {
    setClientes (state, p) {
      state.clientes = p
    },
    addCliente (state, p) {
      let existe = false
      if (p.uid !== undefined)
        existe = state.clientes.find(sel => sel.uid === p.uid)
      else 
        existe = false
      if (!existe)
        state.clientes.push(p)
    },
    setCliente (state, p) {
      state.cliente = p
    },
    comprasYcotis (state, p) {
      state.compras = p.compras
      state.cotizaciones = p.cotizaciones
    },
    comunas (state, p) {
      state.comunas = p
    },
    updateCliente (state, p) {
      let index = state.clientes.findIndex(sel => sel.uid === p.uid)
      state.clientes[index] = p
    }
  },
  actions: {
    comunas (ctx) {
      return new Promise ((resolve, reject) => {
        fb.collection('comunas').doc('lista').get()
        .then(doc => {
          ctx.commit('comunas', doc.data().comunas)
          resolve()
        })
        .catch(e => {
          console.error(e)
          reject()
        })
      })
    },
    crearCliente (ctx, p) {
      return new Promise ((resolve, reject) => {
        au.currentUser.getIdToken(/* forceRefresh */ true)
        .then(token => {
          p.rut = validarRut(p.rut)
          p.timestamp = momento().format()
          let url = 'crearCliente'
          return Vue.prototype.$axios.post(url, {cliente: p, user: token})
        })
        .then(ans => {
          ctx.commit('addCliente', ans.data)
          resolve(ans.data)
        })
        .catch(e => {
          console.error(e)
          reject()
        })
      })
    },
    getAll (ctx) {
      return new Promise ((resolve, reject) => {
        fb.collection('clientes').get()
        .then(results => {
          let all = []
          results.forEach(doc => {
            all.push(doc.data())
          })
          ctx.commit('setClientes', all)
          resolve()
        })
        .catch(e => {
          console.error(e)
          reject()
        })
      })
    },
    getCompras (ctx) {
      return new Promise ((resolve, reject) => {
        let cotis = []
        let compras = []
        fb.collection('cotizaciones').where('usuario', '==', ctx.state.cliente.uid).get()
        .then(results => {
          results.forEach(doc => {
            let cot = doc.data
            cot.id = doc.id
            cotis.push(cot)
          })
          return fb.collection('ventas').where('usuario', '==', ctx.state.cliente.uid).get()
        })
        .then(results => {
          results.forEach(doc => {
            let com = doc.data
            com.id = doc.id
            compras.push(com)
          })
          ctx.commit('comprasYcotis', {compras: compras, cotizaciones: cotis})
          resolve()
        })
        .catch(e => {
          console.error(e)
          reject()
        })
      })
    },
    updateCliente (ctx, p) {
      return new Promise ((resolve, reject) => {
        fb.collection('clientes').doc(p.uid).update(p)
        .then(() => {
          ctx.commit('updateCliente', p)
          ctx.commit('setCliente', p)
          resolve()
        })
        .catch(e => {
          console.error(e)
          reject()
        })
      })
    },
    getGustos (ctx, p) {
      return new Promise ((resolve, reject) => {
        fb.collection('gustos').doc(p.uid).get()
        .then(doc => {
          if (doc.exists)
            resolve(doc.data())
          else 
            resolve({})
        })
        .catch(e => {
          console.error(e)
          reject()
        })
      })
    },
    buscarCliente (ctx, p) {
      return new Promise ((resolve, reject) => {
        if (p.tipo === 'uid') {
          fb.collection('clientes').doc(p.dato).get()
          .then(doc => {
            if (doc.exists)
              resolve(doc.data())
          })
          .catch(e => {
            console.error(e)
            reject()
          })
        } else if (p.tipo === 'rut') {
          fb.collection('clientes').where(p.tipo, '==', p.dato).get()
          .then(results => {
            if (results.empty) {
              resolve({})
            } else {
              results.forEach(doc => {
                resolve(doc.data())
              })
            }
          })
          .catch(e => {
            console.error(e)
            reject()
          })
        }   
      })
    }
  },
  getters: {
    getAll (state) {
      return state.clientes.sort((a, b) => {
        const aL = limpiar(a.apellidos)
        const bL = limpiar(b.apellidos)
        if (aL < bL)
          return -1 
        if (aL > bL)
          return 1
        return 0
      })
    },
    cliente: (state) => state.cliente,
    compras: (state) => state.compras,
    cotis: (state) => state.cotis,
    getSingle: (state) => (p) => {
      if (p.tipo === 'compra')
        return state.compras.find(sel => sel.id === p.id)
      else if (p.tipo === 'cotizacion')
        return state.cotizaciones.find(sel => sel.id === p.id)
    },
    comunas: (state) => state.comunas
  }
}

function validarRut (rut) {
  return rut.replace(/\./g,'').replace(/-/g,'').replace(/\s/g,'').replace(/^0+/,'').toUpperCase()
}
